<div *ngIf="current_page===getIndex('first')">
    <h3 name="subscriptionTitle2">{{'REGISTRATION.STEP.PERSONALIZE.FIRST_QUESTION' | translate}}</h3>
    <ul class="row no-margin-padding">
        <li class="col-md-6 unstyle dual-choice">
            <div class="choice" (click)="next(false)" [ngClass]="{'selected':itemConfig.alreadyOwn===false}">
                <mat-icon name="watchPersonalize" class="icon-choice" aria-hidden="true">shopping_cart</mat-icon>
            </div>
            <h6 class="h6-choice">{{'REGISTRATION.STEP.PERSONALIZE.WATCH_NOT_OWNER' | translate}}</h6>
        </li>
        <li class="col-md-6 unstyle dual-choice">
            <div class="choice" (click)="next(true)" [ngClass]="{'selected':itemConfig.alreadyOwn===true}">
                <mat-icon name="watchID" class="icon-choice" aria-hidden="true">watch</mat-icon>
            </div>
            <h6 class="h6-choice">{{'REGISTRATION.STEP.PERSONALIZE.WATCH_OWNER' | translate}}</h6>
        </li>
    </ul>
    <div class="row col-md-12 controls-button">
        <button mat-stroked-button color="primary" class="pull-left" (click)="previous('first')">
            {{'COMMON.BACK' | translate}}
        </button>
    </div>
</div>
<div *ngIf="current_page===getIndex('identificationNumber')" class="formulaire container-fluid">
    <h3 name="subscriptionTitle3">{{'REGISTRATION.STEP.PERSONALIZE.IDENTIFICATION_NUMBER_TITLE' | translate}}</h3>
    <div style="text-align:center;">
        <mat-form-field class="identificationFormField">
            <mat-label>{{'REGISTRATION.STEP.PERSONALIZE.IDENTIFICATION_NUMBER' | translate}}</mat-label>
            <input matInput name="app-personalize-watch-id-input" appPreventEnter [(ngModel)]="identificationNumber">
        </mat-form-field>
        <mat-icon [matTooltip]="'REGISTRATION.STEP.PERSONALIZE.IDENTIFICATION_NUMBER_HELPER' | translate">help
        </mat-icon>
    </div>
    <div class="row col-md-12  controls-button">
        <button mat-stroked-button color="primary" class="pull-left" (click)="previous('identificationNumber')">
            {{'COMMON.BACK' | translate}}
        </button>
        <button mat-raised-button name="goNext3" class="mat-raised-button mat-primary pull-right"
            [disabled]="!identificationNumber" (click)="identificationNumberIsValid()">
            {{'COMMON.CONTINUE' | translate}}
        </button>
    </div>
</div>
<div *ngIf="current_page===getIndex('selectItem')" class="formulaire container-fluid">
    <h3 name="subscriptionTitle4">{{'REGISTRATION.STEP.PERSONALIZE.SELECT_ITEM' | translate}}</h3>
    <app-item-inventory [itemConfig]="itemConfig" [type]="B2C_BUSINESS" (itemEmitter)="selectItem($event)">
    </app-item-inventory>
    <div class="row col-md-12  controls-button">
        <button mat-stroked-button color="primary" class="pull-left" (click)="previous('selectItem') ">
            {{'COMMON.BACK' | translate}}
        </button>
        <button id="watchContinue" mat-raised-button color="primary" name="goNext4" class="pull-right"
            (click)="continue('selectItem', true) ">
            {{'COMMON.LATER' | translate}}
        </button>
    </div>
    <br>
</div>

<div *ngIf="current_page===getIndex('selectProcess')" class="formulaire container-fluid">
    <h3 name="subscriptionTitle5">{{'REGISTRATION.STEP.PERSONALIZE.SELECT_PROCESS' | translate}}</h3>
    <ul class="row no-margin-padding">
        <li class="col-md-6 unstyle dual-choice">
            <div class="choice" name="app-personalize-family" (click)="nextProcess(false)"
                [ngClass]="{'selected':!isTelecareSelected()}">
                <mat-icon name="watchPersonalize" class="icon-choice" aria-hidden="true">family_restroom</mat-icon>
            </div>
            <h6 class="h6-choice">{{'REGISTRATION.STEP.PERSONALIZE.EMBEDDED' | translate}}</h6>
        </li>
        <li class="col-md-6 unstyle dual-choice">
            <div class="choice" name="app-personalize-telecare" (click)="nextProcess(true)"
                [ngClass]="{'selected':isTelecareSelected()}">
                <mat-icon name="watchID" class="icon-choice" aria-hidden="true">support_agent</mat-icon>
            </div>
            <h6 class="h6-choice">{{'REGISTRATION.STEP.PERSONALIZE.TELECARE' | translate}}</h6>
            <h6 class="h6-choice">{{'REGISTRATION.STEP.PERSONALIZE.TELECARE_PRICE' | translate}}</h6>
        </li>
    </ul>
    <div class="row col-md-12  controls-button">
        <button mat-stroked-button color="primary" class="pull-left" (click)="previous('selectProcess') ">
            {{'COMMON.BACK' | translate}}
        </button>
        <button mat-raised-button color="primary" name="goNext5" class="pull-right"
            (click)="continue('selectProcess') ">
            {{'COMMON.LATER' | translate}}
        </button>
    </div>
    <br>
</div>